export default __webpack_public_path__ + "static/media/Trial of Flame.ad5e7093.jpg";